angular.module('bribac.components.mainGroupOverview', [
  'bribac.components.subGroupOverview',
  'bribac.components.collapsingBox'
])

  .component('mainGroupOverview', {
    templateUrl: 'main-group-overview-component.html',
    bindings: {
      mainGroup: '<',
      showOrganization: '<'
    }
  })
